<template>  
  <div>
    <div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ optionConfig.baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:optionConfig.baseConfig?.title?.textShow?'flex':'none', height: optionConfig.baseConfig.title?.Height + 'px'}">
			<div class="img-icon" :style = "{ width: optionConfig.baseConfig.title?.textWidth + 'px', height: optionConfig.baseConfig.title?.textHeight + 'px', marginLeft: optionConfig.baseConfig.title?.textLeft + 'px', marginRight: optionConfig.baseConfig.title?.textRight + 'px',display:optionConfig.baseConfig?.title?.textIcon?'block':'none'}">
				<img style="height:100%;width:100%" :src="commenUrl+optionConfig.baseConfig?.title?.textIcon" alt="">
			</div>
			<div style="flex:1" :style = "{ fontSize: optionConfig.baseConfig.title?.textSzie + 'px', color: optionConfig.baseConfig.title?.textColor,textAlign: optionConfig.baseConfig.title?.textAlign}">{{optionConfig.baseConfig?.title?.textTitle}}</div>
		</div>
    <div :style="getStyle()">
      <el-image :style="imgStyle()" :src="optionConfig.options.linkUrl||noImg" :fit="optionConfig.options.fit"/>
    </div> 
  </div> 
</template>

<script setup>
import {reactive,ref,computed} from 'vue'
import { useStore } from 'vuex';
const props = defineProps({
    index:{
        type:Number||String,
        default:0
    }
})
const store = useStore();
const componentList = computed(() => store.state.chartData.componentList);
const optionConfig = reactive(componentList.value[props.index].config);
const noImg = require('../../../assets/images/canvas/noImage.png')
const getStyle = () => {
  return {
    width:`${optionConfig.baseConfig.width}px`,
    height:`${optionConfig.baseConfig.height}px`,    
    position:'relative'
  }
}
const imgStyle = ()=>{
  return {
    width:`100%`,
    height:`100%`,
    left:`${optionConfig.baseConfig.left}px`,
    top:`${optionConfig.baseConfig.top}px`,
    position:'absolute'    
  }
}
</script>

<style lang="less" scoped>
</style> 